export const RefOp = ({ value, record }) => record.result?.refOp
